<template>
  <div
    class="popover-wrapper"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @click="togglePopover"
  >
    <slot name="trigger" :togglePopover="togglePopover"></slot>
    <transition name="fade">
      <div
        :style="{ width: contentWidth ? `${contentWidth}px` : undefined }"
        v-if="isOpen"
        class="popover-content"
        ref="popover"
        @click.stop
      >
        <slot name="content" :togglePopover="togglePopover"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from '@vue/composition-api'
import { EventBus } from './eventBus'

export default {
  name: 'Popover',
  props: {
    hovered: {
      type: Boolean,
      default: false
    },
    contentWidth: {
      type: Number,
      default: undefined
    }
  },
  setup(props) {
    const isOpen = ref(false)
    const popover = ref(null)
    let closeTimer = null

    const togglePopover = () => {
      if (!isOpen.value) {
        EventBus.$emit('close-all-popovers')
      }
      isOpen.value = !isOpen.value
      if (isOpen.value) {
        nextTick(() => {
          positionPopover()
        })
      }
    }

    const openPopover = () => {
      EventBus.$emit('close-all-popovers')
      isOpen.value = true
      nextTick(() => {
        positionPopover()
      })
    }

    const closePopover = () => {
      isOpen.value = false
    }

    const positionPopover = () => {
      const trigger = document.querySelector('[slot="trigger"]')
      if (trigger && popover.value) {
        const triggerRect = trigger.getBoundingClientRect()
        const popoverRect = popover.value.getBoundingClientRect()

        const top = triggerRect.bottom + window.scrollY
        const left =
          triggerRect.left +
          triggerRect.width / 2 -
          popoverRect.width / 2 +
          window.scrollX

        popover.value.style.top = `${top}px`
        popover.value.style.left = `${left}px`
      }
    }

    const handleClickOutside = (event) => {
      if (
        !props.hovered &&
        isOpen.value &&
        !popover.value.contains(event.target) &&
        !event.target.closest('.popover-wrapper')
      ) {
        closePopover()
      }
    }

    const handleMouseLeave = () => {
      if (!props.hovered) return
      closeTimer = setTimeout(() => {
        closePopover()
      }, 300)
    }

    const handleMouseEnter = () => {
      if (!props.hovered) return
      clearTimeout(closeTimer)
      openPopover()
    }

    onMounted(() => {
      document.addEventListener('click', handleClickOutside)
      EventBus.$on('close-all-popovers', closePopover)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside)
      EventBus.$off('close-all-popovers', closePopover)
    })

    return {
      isOpen,
      popover,
      togglePopover,
      handleMouseLeave,
      handleMouseEnter
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
